// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"308f4ad8","517":"bab99fb4","667":"9061024c","668":"1aea82b8","739":"310ae109","787":"adfdd28f","959":"a641c2c6"}[chunkId] + ".chunk.js";
};